import { AuditTrail } from '@card-software/nexus-models';
import { Business } from '../finance/business';
import { LotItem } from '../inventory/lot-item';
import { Roll } from '../production/roll';

export enum SecondQualityDispatchStatus {
  Draft = 0,
  Completed = 1,
  Cancelled = 2,
}

export interface ItemLineBGradeInstruction {
  lineId: string;
  itemCode: string;
  itemDescription?: string;
  quantity: number;
  uom: number;
  packageCount: number;
  unitPrice: number;
}

export interface SecondQualityDispatch extends AuditTrail {
  id: string;
  number: string;
  status: SecondQualityDispatchStatus;
  clientReference: string;
  clientName?: string;
  shippingToReference?: string;
  shippingToName?: string;
  shippingTo?: Business;
  shipToAddressCode: string;
  shippingAddress?: string;
  shipmentType: number;
  billToReference?: string;
  billToName?: string;
  billTo?: Business;
  billToAddressCode?: string;
  billingAddress?: string;
  paymentTermClientCode: string;
  paymentTermName?: string;
  invoiceComment?: string;
  invoiceNumber?: string;
  caiAuthorizationId?: string;
  invoiceGeneratedDate?: Date;
  exchangeRate?: number;
  exchangeRateDate?: Date;
  lines: ItemLineBGradeInstruction[];
  scannedRollNumbers: string[];
  scannedRollsUnitPrice?: number;
  scannedRollsItemDescription?: string;
  scannedRolls: Roll[];
  scannedLotItemNumbers: string[];
  scannedLotItemsUnitPrice?: number;
  scannedLotItemsItemDescription?: string;
  scannedLotItems: LotItem[];
}
